module.exports = __webpack_public_path__ + "static/media/tr.1e61ed46.png";